"use client";

import { MemoizedMarkdown } from "@west-tennessee-consulting/meridian/components/MemoizedMarkdown";
import React from "react";

interface MarkdownComponentsProps {
  markdownContent: string;
}

/**
 * AI-summary markdown.
 *
 * Delegates to `MemoizedMarkdown` — the ONE renderer that covers every block
 * construct our models emit. This file used to carry its own component map with
 * ten element overrides and no `table` / `thead` / `th` / `td` / `hr` / `a` /
 * `pre` / `h4`–`h6`, which read as "the rest is styled by `prose`" and was not:
 * Hub does NOT load `@tailwindcss/typography`, so `.prose` here only defines
 * `--tw-prose-*` variables that nothing consumes (see `app/globals.css`).
 * Tailwind's preflight had already stripped every browser default, so a GFM
 * table in a summary rendered as borderless, padding-less cells run together —
 * the same "tables don't work" report as the phone, from a different cause.
 *
 * The wrapper keeps no `prose` class on purpose: the only live `.prose` rule is
 * a global `.prose a`, and it outranks the renderer's own link styling.
 */
export function MarkdownComponents({ markdownContent }: MarkdownComponentsProps) {
  if (!markdownContent) return null;

  return (
    <div className="max-w-none text-sm md:text-base">
      <MemoizedMarkdown id="ai-summary" content={markdownContent} />
    </div>
  );
}
